import React from 'react';
import DashboardModal from '../DashboardModal';
import { useViewerStore } from '../../../../../store/store';
import {
    SITE_VIEWER_UNAVAILABLE_TITLE,
    dismissSiteViewerUnavailableModal,
} from '../../../../../helpers/siteViewer3dAccess';

export type SiteViewerUnavailableModalProps = {
    theme: 'dark' | 'light';
};

/** Controlled modal for blocked 3D viewer entry points (reliable z-index above dashboard overlay). */
export const SiteViewerUnavailableModal: React.FC<SiteViewerUnavailableModalProps> = ({ theme }) => {
    const prompt = useViewerStore((s) => s.siteViewerUnavailablePrompt);
    const open = Boolean(prompt);

    return (
        <DashboardModal
            open={open}
            onClose={dismissSiteViewerUnavailableModal}
            title={SITE_VIEWER_UNAVAILABLE_TITLE}
            theme={theme}
            width={480}
            zIndex={12000}
            getContainer={() => document.body}
            maskClosable
        >
            <p className="obd-site-viewer-unavailable-modal__body">{prompt}</p>
        </DashboardModal>
    );
};
